import { Link } from "@tanstack/react-router"
import { useLocale } from "@/base"
import { LanguageSwitcher } from "@/profile"
import { Trans, useT } from "@/i18n"

export default function Footer() {
  const { t } = useT("content")
  const locale = useLocale()

  return (
    <footer className="border-t border-border/40">
      <div className="mx-auto flex max-w-250 items-center justify-between px-6 py-6 text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <span>
            <Trans
              t={t}
              i18nKey="poweredBy"
              components={{
                holigralLink: (
                  <a
                    href="https://holigral.com"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="underline-offset-4 transition-colors hover:text-foreground hover:underline"
                  />
                ),
              }}
            />
          </span>
        </div>
        <div className="flex items-center gap-4 sm:gap-5">
          <Link
            to="/$locale/legal/$slug"
            params={{ locale, slug: "terms" }}
            className="transition-colors hover:text-foreground"
          >
            {t("terms")}
          </Link>
          <Link
            to="/$locale/legal/$slug"
            params={{ locale, slug: "privacy" }}
            className="transition-colors hover:text-foreground"
          >
            {t("privacy")}
          </Link>
          <Link
            to="/$locale/contact"
            params={{ locale }}
            className="transition-colors hover:text-foreground"
          >
            {t("contact")}
          </Link>
          <LanguageSwitcher />
        </div>
      </div>
    </footer>
  )
}
